var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRyo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#3D58B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99213 2.25C5.274 2.25 2.25 5.274 2.25 8.99213C2.25 12.7102 5.274 15.7331 8.99213 15.7331C12.7102 15.7331 15.7331 12.7097 15.7331 8.99213C15.7337 5.274 12.7097 2.25 8.99213 2.25ZM8.99213 3.168C9.7572 3.16704 10.515 3.31703 11.222 3.60939C11.929 3.90174 12.5714 4.33072 13.1124 4.87173C13.6533 5.41275 14.0822 6.05519 14.3745 6.76223C14.6668 7.46928 14.8167 8.22705 14.8157 8.99213C14.8167 9.75716 14.6667 10.5149 14.3744 11.2218C14.082 11.9288 13.6531 12.5712 13.1122 13.1122C12.5712 13.6531 11.9288 14.082 11.2218 14.3744C10.5149 14.6667 9.75716 14.8167 8.99213 14.8157C8.22705 14.8167 7.46928 14.6668 6.76223 14.3745C6.05519 14.0822 5.41275 13.6533 4.87173 13.1124C4.33072 12.5714 3.90174 11.929 3.60939 11.222C3.31703 10.515 3.16704 9.7572 3.168 8.99213C3.16704 8.22702 3.31703 7.46924 3.60937 6.76219C3.90172 6.05514 4.33069 5.41271 4.8717 4.8717C5.41271 4.33069 6.05514 3.90172 6.76219 3.60937C7.46924 3.31703 8.22702 3.16704 8.99213 3.168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4873 6.50244V11.4806H11.4964V6.50244H6.4873ZM7.30293 7.31807H10.6802V10.6649H7.30349V7.31807H7.30293Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRyo);
export default __webpack_public_path__ + "static/media/ryo.203c748a1e84b98301be698555be4747.svg";
export { ForwardRef as ReactComponent };